/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {

    export class MenuLinkService extends HttpHandlerService {
        constructor($http: ng.IHttpService) {
            super($http);
        }

        public addMenuLink(menuLink: models.MenuLinkDto): ng.IPromise<Wars.Domain.Model.Dtos.MenuLinkDto> {
            var params = menuLink;
            this.handlerUrl = "api/ContentManagement/MenuLink/AddMenuLink";
            return this.usePostHandler(params);
        }

        public updateMenuLink(menuLink: Wars.Domain.Model.Dtos.MenuLinkDto): ng.IPromise<Wars.Domain.Model.Dtos.MenuLinkDto> {
            var params = menuLink;
            this.handlerUrl = "api/ContentManagement/MenuLink/UpdateMenuLink";
            return this.usePostHandler(params);
        }

        public updateMenuLinks(menuLinks: Wars.Domain.Model.Dtos.MenuLinkDto[]): ng.IPromise<Wars.Domain.Model.Dtos.MenuLinkDto> {
            var params = menuLinks;
            this.handlerUrl = "api/ContentManagement/MenuLink/UpdateMenuLinks";
            return this.usePostHandler(params);
        }

        public deleteMenuLink(menuLink: Wars.Domain.Model.Dtos.MenuLinkDto): ng.IPromise<Wars.Domain.Model.Dtos.MenuLinkDto> {
            var params = menuLink;
            this.handlerUrl = "api/ContentManagement/MenuLink/DeleteMenuLink";
            return this.usePostHandler(params);
        }
    }

    export class MenuItemService extends HttpHandlerService {
        constructor($http: ng.IHttpService) {
            super($http);
        }

        public getMenuItems(): ng.IPromise<Wars.Domain.Model.Dtos.MenuItemDto[]> {
            var params: any = {};
            this.handlerUrl = "api/ContentManagement/MenuItem/GetMenuItems";
            return this.useGetHandler(params).then(
                (result: Wars.Domain.Model.Dtos.MenuItemDto[]) => {
                    return result;
                });
        }

        public addMenuItem(menuItem: models.MenuItemDto): ng.IPromise<Wars.Domain.Model.Dtos.MenuItemDto> {
            var params = menuItem;
            this.handlerUrl = "api/ContentManagement/MenuItem/AddMenuItem";
            return this.usePostHandler(params);
        }

        public updateMenuItem(menuItem: Wars.Domain.Model.Dtos.MenuItemDto): ng.IPromise<Wars.Domain.Model.Dtos.MenuItemDto> {
            var params = menuItem;
            this.handlerUrl = "api/ContentManagement/MenuItem/UpdateMenuItem";
            return this.usePostHandler(params);
        }

        public updateMenuItems(menuItem: Wars.Domain.Model.Dtos.MenuItemDto[]): ng.IPromise<Wars.Domain.Model.Dtos.MenuItemDto> {
            var params = menuItem;
            this.handlerUrl = "api/ContentManagement/MenuItem/UpdateMenuItems";
            return this.usePostHandler(params);
        }

        public deleteMenuItem(menuItem: Wars.Domain.Model.Dtos.MenuItemDto): ng.IPromise<Wars.Domain.Model.Dtos.MenuItemDto> {
            var params = menuItem;
            this.handlerUrl = "api/ContentManagement/MenuItem/DeleteMenuItem";
            return this.usePostHandler(params);
        }
    }
}

warsApp.registerService('MenuItemService', ['$http']);
warsApp.registerService('MenuLinkService', ['$http']);